// Components
import { VBtn } from '../VBtn'

// Utilities
import { defineComponent } from '@/util'

export default defineComponent({
  ...VBtn,
  name: 'VPaginationBtn',
})
